import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';

const GSTCalculator = ({ show, onClose }) => {
  const [amount, setAmount] = useState('');
  const [gstType, setGstType] = useState('exclusive'); // exclusive / inclusive
  const [gstRate, setGstRate] = useState('');
  const [discountType, setDiscountType] = useState({ value: '%', label: '%' });
  const [discountValue, setDiscountValue] = useState('');
  const [gstAmount, setGstAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [roundedAmount, setRoundedAmount] = useState(0);

  const discountOptions = [
    { value: '%', label: '%' },
    { value: '$', label: '₹' }
  ];

  // Calculation function
  useEffect(() => {
    if (!amount || !gstRate) {
      setGstAmount(0);
      setTotalAmount(0);
      setRoundedAmount(0);
      return;
    }

    let amt = parseFloat(amount);
    let gst = parseFloat(gstRate);
    let discount = parseFloat(discountValue) || 0;

    // Apply discount first
    if (discountType.value === '%') {
      amt = amt - (amt * discount) / 100;
    } else {
      amt = amt - discount;
    }

    let gstAmt = 0;
    let total = 0;

    if (gstType === 'exclusive') {
      gstAmt = (amt * gst) / 100;
      total = amt + gstAmt;
    } else {
      // inclusive GST
      gstAmt = (amt * gst) / (100 + gst);
      total = amt;
    }

    setGstAmount(gstAmt);
    setTotalAmount(total);
    setRoundedAmount(Math.round(total));

  }, [amount, gstType, gstRate, discountType, discountValue]);

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>GST Calculator</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="text-black fw-bold">Enter Amount</Form.Label>
            <Form.Control
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
                 className="text-black fw-normal"
            />
          </Form.Group>


          <Form.Group className="mb-3">
            <Form.Label className="text-black fw-bold">Enter GST Rate (%)</Form.Label>
            <Form.Control
              type="number"
              value={gstRate}
              onChange={(e) => setGstRate(e.target.value)}
              placeholder="Enter GST rate"
                 className="text-black fw-normal"
            />
          </Form.Group>

                    <Form.Group className="mb-3">
            <Form.Label className="text-black fw-bold">GST Type</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Exclusive"
                name="gstType"
                id="exclusive"
                value="exclusive"
                checked={gstType === 'exclusive'}
                onChange={(e) => setGstType(e.target.value)}
                   className="text-black fw-normal"
              />
              <Form.Check
                inline
                type="radio"
                label="Inclusive"
                name="gstType"
                id="inclusive"
                value="inclusive"
                checked={gstType === 'inclusive'}
                onChange={(e) => setGstType(e.target.value)}
                   className="text-black fw-normal"
              />
            </div>
          </Form.Group>


          <Form.Group className="mb-3">
            <Form.Label className="text-black fw-bold">Enter Discount</Form.Label>
            <Row>
              <Col>
                <Form.Control
                  type="number"
                  value={discountValue}
                  onChange={(e) => setDiscountValue(e.target.value)}
                  placeholder="Enter discount"
                     className="text-black fw-normal"
                />
              </Col>
              <Col>
                <Select
                  options={discountOptions}
                  value={discountType}
                  onChange={(val) => setDiscountType(val)}
                  className="text-black fw-normal"
                />
              </Col>
            </Row>
          </Form.Group>

          <hr />
    
         <div className="d-flex justify-content-between mb-2">
        <strong className="text-black fs-5">GST Amount:</strong>
        <span className="text-black fs-5">₹{gstAmount.toFixed(2)}</span>
        </div>
        <div className="d-flex justify-content-between mb-2">
        <strong className="text-black fs-5">Total Amount ({gstType} GST):</strong>
        <span className="text-black fs-5">₹{totalAmount.toFixed(2)}</span>
        </div>
        <div className="d-flex justify-content-between">
        <strong className="text-black fs-5">Rounded Total Amount:</strong>
        <span className="text-danger fw-bold fs-5">₹{roundedAmount}</span>
        </div>


        </Form>
      </Modal.Body>
      
    </Modal>
  );
};

export default GSTCalculator;
